import { render, staticRenderFns } from "./NarliFerryboatStatsByProcessTypeGraph.vue?vue&type=template&id=ec440132&"
import script from "./NarliFerryboatStatsByProcessTypeGraph.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByProcessTypeGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports